import React, { useState, useEffect } from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { SearchIcon, Close } from 'assets'; // Assuming Close is the X mark asset.

function CTSearchView(props) {
  const [inputValue, setInputValue] = useState(props.value || "");

  // Keep internal input value in sync with the controlled `value` prop so that
  // parent-driven resets (e.g. Clear Search from Advanced Search) actually
  // clear the visible text in the search box.
  useEffect(() => {
    if (props.value !== undefined && props.value !== inputValue) {
      setInputValue(props.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    props.onChange(event);
  };

  const handleClear = () => {
    setInputValue("");
    props.onChangeclear({ target: { value: "" } });
  };

  return (
    <div>
      <style>
        {`
          @keyframes blink {
            0% { opacity: 1; }
            50% { opacity: 0.3; }
            100% { opacity: 1; }
          }
        `}
      </style>
      <div
        className="col-12 bg-white mt-2"
        style={{
          justifyContent: "center",
          textAlign: "center", // Changed from "left" to "center"
          alignItems: "center", // Changed from "flex-start" to "center"
          border: "1px solid #ccc", // Added border
          borderRadius: "5px", // Optional: Added border radius for rounded corners
          backgroundColor: "#f5f5f5",// Added border color
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" // Added shadow
        }}
      >
        <label
          style={{
            fontSize: 18,
            fontWeight: "bold",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            color: props.color ? "white" : "black",
          }}
        >
          {props.heading}
        </label>

        <TextField

          autoComplete="off"
          value={inputValue}
          disabled={props.isDisable}
          onChange={handleInputChange}
          variant="standard"
          placeholder={props.placeholder}
          className="col-12 MuiInputBase-input-search bg-white"
          style={{
            fontSize: 9,
            backgroundColor: "red",
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: 5,
            paddingBottom: 5,
            borderStyle: "none",
            borderRadius: 10,
            cursor: "default",
          }}
          InputProps={{
            disableUnderline: true,
            startAdornment: (

              <InputAdornment position="start">
                <img
                  src={SearchIcon}
                  style={{ width: "30px", height: "30px", marginLeft: "10px" }} // Added marginLeft to move it to the right
                  alt="search-icon"
                />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {props.showAdvanceSearch && (
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      marginRight: "10px",
                      textDecoration: "underline",
                    }}
                    onClick={props.advanceSearchClick}
                    className="text-primary"
                  >
                  {props.showBlink && (
                    <span
                      style={{
                        display: "inline-block",
                        width: "12px",
                        height: "12px",
                        backgroundColor: "#32a852",
                        borderRadius: "50%",
                        marginRight: "5px",
                        animation: "blink 1s infinite",
                      }}
                    ></span>
                    )}
                    Advanced Search
                  </span>
                )}
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    marginRight: "10px",
                    textDecoration: "underline",
                  }}
                  onClick={handleClear}
                  className="text-danger"
                >
                  Clear Search
                </span>


              </InputAdornment>
            ),
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "10px",
          fontSize: "14px",
          fontWeight: "bold",
        }}
      >

      </div>
    </div>
  );
}

export default CTSearchView;
